import { getCurrentScope, onScopeDispose, ref } from 'vue';

/** Far below MAX_AUDIT_RUN_AGE_MS: a marker's expiry has to reach the surface without a busy tick. */
const TICK_MS = 15000;

const now = ref(Date.now());

let consumers = 0;
let timer = null;

/**
 * Wall-clock time as something a computed can depend on.
 *
 * @returns {import('vue').Ref<number>}
 */
// eslint-disable-next-line import/prefer-default-export
export function useAuditRunClock() {
  if (!timer) {
    now.value = Date.now();
  }

  // Callers outside a component — the wizard reporting a signature — read it once and dispose nothing.
  if (!getCurrentScope()) {
    return now;
  }

  consumers += 1;
  timer ??= setInterval(() => { now.value = Date.now(); }, TICK_MS);

  onScopeDispose(() => {
    consumers -= 1;

    if (!consumers) {
      clearInterval(timer);
      timer = null;
    }
  });

  return now;
} // useAuditRunClock()
